import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from './components/Header';
import Footer from './components/Footer';
import FaqSection from './components/FaqSection';
import ScrollToTop from './components/ScrollToTop';
import StickyCtaModal from './components/StickyCtaModal';
import FloatingContactButton from './components/FloatingContactButton';
import CanonicalManager from './components/CanonicalManager';

import HomePage from './pages/HomePage';
import NewRoofPage from './pages/NewRoofPage';
import AreaPage from './pages/AreaPage';
import ProcessPage from './pages/ProcessPage';
import AsbestosPage from './pages/AsbestosPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import EnergySolutionsPage from './pages/EnergySolutionsPage';
import KnowledgePage from './pages/KnowledgePage';
import KnowledgeDetailPage from './pages/KnowledgeDetailPage';
import ProjectsPage from './pages/ProjectsPage';
import ReviewsPage from './pages/ReviewsPage';
import AboutPage from './pages/AboutPage';
import WarrantiesPage from './pages/WarrantiesPage';
import JobsPage from './pages/JobsPage';
import ContactPage from './pages/ContactPage';
import PriceCalculatorPage from './pages/PriceCalculatorPage';
import InsulationCalculatorPage from './pages/InsulationCalculatorPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-out',
      once: true,
      offset: 40,
    });
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [location.pathname]);

  const isHomePage = location.pathname === '/';

  return (
    <>
      <CanonicalManager />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-white text-stone-900 font-sans selection:bg-amber-500 selection:text-white">
        <Header />
        <main className={`flex-grow ${!isHomePage ? 'pt-[68px] sm:pt-[78px] xl:pt-[122px]' : ''}`}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            
            {/* Main Pages */}
            <Route path="/nyt-tag" element={<NewRoofPage />} />
            <Route path="/p/nyt-tag" element={<NewRoofPage />} />
            <Route path="/processen" element={<ProcessPage />} />
            <Route path="/p/nyt-tag/processen" element={<ProcessPage />} />
            <Route path="/asbest-autoriseret" element={<AsbestosPage />} />
            <Route path="/p/nyt-tag/asbest-autoriseret" element={<AsbestosPage />} />
            <Route path="/p/nyt-tag/beregn-din-pris" element={<Navigate to="/prisberegner" replace />} />
            <Route path="/nyt-tag/:area" element={<AreaPage />} />
            <Route path="/p/nyt-tag/:area" element={<AreaPage />} />
            
            {/* Ydelser & Energiløsninger */}
            <Route path="/ydelser" element={<ServicesPage />} />
            <Route path="/ydelser/:slug" element={<ServiceDetailPage />} />
            <Route path="/c/ydelser/:slug" element={<ServiceDetailPage />} />
            <Route path="/energiloesninger" element={<EnergySolutionsPage />} />
            <Route path="/p/energiloesninger" element={<EnergySolutionsPage />} />
            
            {/* Viden (Knowledge Base) */}
            <Route path="/viden" element={<KnowledgePage />} />
            <Route path="/p/viden" element={<KnowledgePage />} />
            <Route path="/viden/:slug" element={<KnowledgeDetailPage />} />
            <Route path="/c/viden/:slug" element={<KnowledgeDetailPage />} />
            
            {/* Projects & Reviews */}
            <Route path="/projekter" element={<ProjectsPage />} />
            <Route path="/p/projekter" element={<ProjectsPage />} />
            <Route path="/anmeldelser" element={<ReviewsPage />} />
            
            {/* Company Pages */}
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/profil" element={<AboutPage />} />
            <Route path="/p/profil" element={<AboutPage />} />
            <Route path="/garantier" element={<WarrantiesPage />} />
            <Route path="/p/garantier" element={<WarrantiesPage />} />
            <Route path="/job" element={<JobsPage />} />
            <Route path="/p/job" element={<JobsPage />} />
            <Route path="/c/job/:slug" element={<JobsPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/p/kontakt" element={<ContactPage />} />
            
            {/* Price Calculator Routes */}
            <Route path="/prisberegner" element={<PriceCalculatorPage />} />
            <Route path="/p/prisberegner-tag" element={<Navigate to="/prisberegner" replace />} />
            <Route path="/p/prisberegner-energiloesninger" element={<InsulationCalculatorPage />} />
            <Route path="/prisberegner-energiloesninger" element={<InsulationCalculatorPage />} />
            <Route path="/prisberegner-isolering" element={<InsulationCalculatorPage />} />
            <Route path="/p/nyt-tag/beregn-din-pris" element={<Navigate to="/prisberegner" replace />} />

            {/* Error Pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <FloatingContactButton />
      <StickyCtaModal />
    </>
  );
}
